import { render } from "./App.vue?vue&type=template&id=58de063a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=58de063a&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=58de063a&lang=scss"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58de063a"]])

export default __exports__